import * as React from 'react'

import { CmsPage, RenderCmsComponent } from 'bloomreach-experience-react-sdk'
import getConfig from 'next/config'
import NextRouter from 'next/router'

import { WebPage } from '@grandvision/analytics'
import { getAlgoliaConfigFromBloomreach, getPageSeo } from '@grandvision/bloomreach'
import { AlgoliaConfigProvider, fetchAlgoliaConfig } from '@grandvision/search'
import { Locales } from '@grandvision/state'

import componentDefinitions from '../../cms/component-definitions'
import Layout from '../../components/Layout'
import { createAlgoliaConfig } from '../../util/algolia'

const { publicRuntimeConfig } = getConfig()

const ContainerPage = ({
  pageModel,
  asPath,
  preview,
  request,
  labels,
  isSolaris,
  algoliaConfig,
}) => {
  if (!pageModel) {
    console.error(`No pageModel found for path: ${asPath}!`)
    return null
  }

  const seoData = getPageSeo(pageModel)

  return (
    <CmsPage
      cmsUrls={publicRuntimeConfig.bloomreach.cmsUrls}
      pageModel={{ ...pageModel, labels, request }}
      request={request}
      componentDefinitions={componentDefinitions}
    >
      {() => {
        const content = (
          <Layout pageModel={pageModel} asPath={asPath} isSolaris={isSolaris} preview={preview}>
            <RenderCmsComponent />
            {pageModel.page.name === 'homepage' && (
              <WebPage
                pageType="Home"
                url={seoData.canonicalUrl}
                name={seoData.title}
                description={seoData.description}
              />
            )}
          </Layout>
        )

        if (!algoliaConfig.isEnabled) {
          return content
        }

        return (
          <AlgoliaConfigProvider {...algoliaConfig} NextRouter={NextRouter}>
            {content}
          </AlgoliaConfigProvider>
        )
      }}
    </CmsPage>
  )
}

ContainerPage.getInitialProps = async ({ asPath, query }) => {
  const { pageModel, request, isSolaris, preview } = query as any

  const algoliaConfig = await fetchAlgoliaConfig({
    ...createAlgoliaConfig(asPath),
    ...getAlgoliaConfigFromBloomreach(pageModel),
    locale: Locales[query.locale],
  })

  return {
    asPath,
    pageModel,
    preview,
    request,
    isSolaris,
    algoliaConfig,
  }
}

export default ContainerPage
